module.exports = __webpack_public_path__ + "img/logo.d22887ad.png";